module.exports = __webpack_public_path__ + "img/2.76a80fdf.png";